/* COLD PACK v4 – ajoute/retire l'emballage pour les produits taggés "frais".
   Utilise renderContents du tiroir quand disponible, fallback injection sinon. */
(function () {
  if (window.__COLDPACK_V4__) return; window.__COLDPACK_V4__ = true;

  const TH = window.THERMAL || {};
  if (!TH.variantId) { console.warn('[COLD PACK v4] THERMAL absent → inactif'); return; }
  console.info('[COLD PACK v4] hook installé, variantId=', TH.variantId);

  const ORIG_FETCH = window.fetch.bind(window);
  let running = false;

  async function getCart() {
    const r = await ORIG_FETCH('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    return r.json();
  }
  async function addVariant(id, qty = 1) {
    return ORIG_FETCH('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    });
  }
  async function updateByVariant(id, qty) {
    return ORIG_FETCH('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: { [id]: qty } })
    });
  }

  const innerSel = (id) => id === 'cart-drawer' ? '#CartDrawer' : '#cart-icon-bubble';
  const hasFraisItem = (items) => items.some(it => it.properties && (it.properties._is_frais === '1' || it.properties._is_frais === 1));
  const hasThermal   = (items) => items.some(it => String(it.variant_id) === String(TH.variantId));

  async function refreshSections() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];

    // 1) JSON + renderContents si présent
    try {
      const url = `/?sections=${ids.join(',')}&sections_url=/cart`;
      const sections = await ORIG_FETCH(url, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());

      const drawer = document.querySelector('cart-drawer');
      if (drawer?.renderContents) {
        drawer.renderContents({
          id: Date.now(),
          sections: {
            'cart-drawer': sections['cart-drawer'] || '',
            'cart-icon-bubble': sections['cart-icon-bubble'] || ''
          }
        });
        return;
      }

      // Fallback injection manuelle
      ids.forEach(id => {
        const html = sections[id]; if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const srcRoot  = doc.getElementById(`shopify-section-${id}`) || doc.querySelector('.shopify-section') || doc.body;
        const srcInner = doc.querySelector(innerSel(id)) || (srcRoot ? srcRoot.querySelector(innerSel(id)) : null);
        const tgtInner = document.querySelector(innerSel(id));
        const tgtRoot  = document.getElementById(`shopify-section-${id}`);

        if (tgtInner && srcInner) {
          tgtInner.innerHTML = srcInner.innerHTML;
        } else if (tgtInner && srcRoot) {
          const sub = srcRoot.querySelector(innerSel(id)) || srcRoot; // évite #CartDrawer imbriqué
          tgtInner.innerHTML = sub.innerHTML;
        } else if (tgtRoot && srcRoot) {
          tgtRoot.innerHTML = srcRoot.innerHTML;
        }
      });

      // Ouvre/maintient le tiroir
      if (drawer) {
        drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
        drawer.open?.();
      }
      return;
    } catch (e) {
      console.warn('[COLD PACK v4] JSON sections failed → fallback HTML', e);
    }

    // 2) Fallback HTML
    for (const id of ['cart-drawer','cart-icon-bubble']) {
      try {
        const url = id === 'cart-drawer'
          ? '/cart?section_id=cart-drawer'
          : '/?section_id=cart-icon-bubble&sections_url=/cart';

        const html = await ORIG_FETCH(url, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const srcRoot  = doc.getElementById(`shopify-section-${id}`) || doc.querySelector('.shopify-section') || doc.body;
        const srcInner = doc.querySelector(innerSel(id)) || (srcRoot ? srcRoot.querySelector(innerSel(id)) : null);
        const tgtInner = document.querySelector(innerSel(id));
        const tgtRoot  = document.getElementById(`shopify-section-${id}`);

        if (tgtInner && srcInner) {
          tgtInner.innerHTML = srcInner.innerHTML;
        } else if (tgtInner && srcRoot) {
          const sub = srcRoot.querySelector(innerSel(id)) || srcRoot;
          tgtInner.innerHTML = sub.innerHTML;
        } else if (tgtRoot && srcRoot) {
          tgtRoot.innerHTML = srcRoot.innerHTML;
        }
      } catch (e) { console.warn('[COLD PACK v4] fallback error for', id, e); }
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) { drawer.querySelector('.drawer__inner')?.classList.remove('is-empty'); drawer.open?.(); }
  }

  async function ensureThermal() {
    if (running) return; running = true;
    try {
      const cart = await getCart();
      const needThermal = hasFraisItem(cart.items);
      const has = hasThermal(cart.items);

      if (needThermal && !has)      { await addVariant(TH.variantId, 1); await refreshSections(); }
      else if (!needThermal && has) { await updateByVariant(TH.variantId, 0); await refreshSections(); }
    } catch (e) { console.warn('[COLD PACK v4] ensureThermal error:', e); }
    finally { running = false; }
  }

  // Exposition
  window.CORNICHON_COLD_PACK = { ensureThermal };

  // Hook cart mutations
  window.fetch = function (input, init = {}) {
    const url = (typeof input === 'string') ? input : (input?.url || '');
    const isCartMutation = /\/cart\/(add|update|change)\.js/i.test(url);
    return ORIG_FETCH(input, init).then(async (res) => {
      try { if (isCartMutation && res.ok) setTimeout(ensureThermal, 120); } catch(_) {}
      return res;
    });
  };

  document.addEventListener('DOMContentLoaded', () => setTimeout(ensureThermal, 0));
})();
